(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.product-tabs').forEach(function (tabs) {
      tabs.querySelectorAll('.product-tabs__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.dataset.tab;

          tabs.querySelectorAll('.product-tabs__tab').forEach(function (t) {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');
          });
          tabs.querySelectorAll('.product-tabs__panel').forEach(function (p) {
            p.classList.remove('active');
          });
          tab.classList.add('active');
          tab.setAttribute('aria-selected', 'true');
          tabs.querySelector('[data-panel="' + target + '"]').classList.add('active');

          if (target === 'velemenyek') {
            var reviewSection = document.querySelector('.jdgm-widget, [id*="judgeme"], [id*="review_widget"]');
            if (reviewSection) {
              setTimeout(function () {
                reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }, 50);
            }
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
